import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useCSuiteAuth } from "../state/CSuiteAuthContext";

/**
 * Gate for operator routes (/projects, /projects/:id). Uses the same auth
 * context as the C-Suite portal — single shared login model.
 */
export default function HarmonizerProtected({ children }) {
  const { user, loading } = useCSuiteAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-zinc-500">
        <div className="flex items-center gap-2 font-mono text-xs">
          <Loader2 size={14} className="animate-spin"/> Checking session…
        </div>
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return children;
}
